/* ==========================================================================
   FROSTLY ADV1 — comportamento da página
   Cobre: sticky CTA pós-hero, tracking §9.1, UTM passthrough §8.3,
   scroll reveal conservador, view-events de secção.
   Sem dependências. Não bloqueia render.
   ========================================================================== */
(function () {
  'use strict';

  // As sections são independentes no theme editor, por isso o escopo é o
  // documento e não um wrapper único. A página só carrega este ficheiro no
  // template do advertorial.
  var root = document;
  var styleHost = document.documentElement;
  if (!document.querySelector('.adv')) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------------
     Tracking — dispara em dataLayer, Meta Pixel (trackCustom) e CustomEvent.
     Nenhum deles é obrigatório: se não existir, falha em silêncio.
     ---------------------------------------------------------------------- */
  var fired = Object.create(null);

  function track(name, params) {
    var payload = params || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) {}
    try {
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name, payload);
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('adv1', { detail: Object.assign({ name: name }, payload) }));
    } catch (e) {}
  }

  function trackOnce(name, params) {
    if (fired[name]) return;
    fired[name] = true;
    track(name, params);
  }

  // Adiado um tick para que listeners registados no mesmo turno o apanhem.
  window.setTimeout(function () {
    trackOnce('adv1_view', { page: 'adv1' });
  }, 0);

  /* ------------------------------------------------------------------------
     UTM passthrough — todo CTA leva a query string da sessão para a PDP.
     Faz-se em JS porque a página é servida em cache pela CDN da Shopify.
     ---------------------------------------------------------------------- */
  function currentQuery() {
    var q = window.location.search;
    if (q && q.length > 1) return q.substring(1);
    // fallback: guardamos a primeira query da sessão (o utilizador pode ter
    // navegado internamente e perdido os parâmetros do anúncio)
    try {
      return window.sessionStorage.getItem('adv1_q') || '';
    } catch (e) {
      return '';
    }
  }

  (function persistQuery() {
    var q = window.location.search;
    if (q && q.length > 1) {
      try { window.sessionStorage.setItem('adv1_q', q.substring(1)); } catch (e) {}
    }
  })();

  function decorate(link) {
    var extra = currentQuery();
    if (!extra) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;

    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    var incoming = new URLSearchParams(extra);
    incoming.forEach(function (value, key) {
      if (!url.searchParams.has(key)) url.searchParams.set(key, value);
    });
    link.setAttribute('href', url.toString());
  }

  var ctas = root.querySelectorAll('[data-cta-location]');
  Array.prototype.forEach.call(ctas, function (cta) {
    decorate(cta);
    cta.addEventListener('click', function () {
      var where = cta.getAttribute('data-cta-location') || 'unknown';
      track('adv1_cta_click_' + where, { location: where });
      track('adv1_to_pdp', { location: where, href: cta.getAttribute('href') });
    });
  });

  /* ------------------------------------------------------------------------
     Sticky CTA — só depois do hero sair do viewport, escondido no footer.
     ---------------------------------------------------------------------- */
  var sticky = root.querySelector('[data-adv-sticky]');
  var hero = root.querySelector('[data-adv-hero]');
  var foot = root.querySelector('[data-adv-foot]');

  if (sticky && 'IntersectionObserver' in window) {
    var pastHero = false;
    var atFoot = false;

    var apply = function () {
      var on = pastHero && !atFoot;
      sticky.classList.toggle('is-on', on);
      // reserva espaço no fim da página para a barra não tapar conteúdo
      styleHost.style.setProperty('--adv-sticky-h', on ? sticky.offsetHeight + 'px' : '0px');
    };

    if (hero) {
      new IntersectionObserver(function (entries) {
        pastHero = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        apply();
      }, { threshold: 0 }).observe(hero);
    } else {
      pastHero = true;
    }

    if (foot) {
      new IntersectionObserver(function (entries) {
        atFoot = entries[0].isIntersecting;
        apply();
      }, { threshold: 0 }).observe(foot);
    }

    apply();
  }

  /* ------------------------------------------------------------------------
     Scroll depth — 25 / 50 / 75 / 90
     ---------------------------------------------------------------------- */
  (function depth() {
    var marks = [25, 50, 75, 90];
    var last = 0;

    function read() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var pct = ((window.scrollY || doc.scrollTop) / scrollable) * 100;
      for (var i = 0; i < marks.length; i++) {
        if (pct >= marks[i]) trackOnce('adv1_scroll_' + marks[i], { depth: marks[i] });
      }
      if (fired.adv1_scroll_90) window.removeEventListener('scroll', onScroll);
    }

    // Throttle por tempo em vez de requestAnimationFrame: rAF não corre em
    // separadores em segundo plano nem em alguns contextos de medição.
    function onScroll() {
      var now = new Date().getTime();
      if (now - last < 120) return;
      last = now;
      read();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    read();
  })();

  /* ------------------------------------------------------------------------
     View-events de secção (comparison / airflow trap / proof) + reveal
     ---------------------------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var viewObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var name = entry.target.getAttribute('data-adv-view');
        if (name) trackOnce('adv1_' + name + '_view', { section: name });
        viewObs.unobserve(entry.target);
      });
      // threshold em percentagem do ELEMENTO: uma section mais alta que o
      // viewport nunca chegaria a 35%. Dispara quando o topo da section sobe
      // acima de 75% da altura do ecrã — funciona a qualquer altura.
    }, { threshold: 0, rootMargin: '0px 0px -25% 0px' });

    Array.prototype.forEach.call(root.querySelectorAll('[data-adv-view]'), function (el) {
      viewObs.observe(el);
    });

    if (!reduce) {
      var revealObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealObs.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

      Array.prototype.forEach.call(root.querySelectorAll('[data-adv-reveal]'), function (el) {
        revealObs.observe(el);
      });
    }
  } else {
    // sem IntersectionObserver: mostra tudo, sem reveal
    Array.prototype.forEach.call(root.querySelectorAll('[data-adv-reveal]'), function (el) {
      el.classList.add('is-in');
    });
  }

  /* ------------------------------------------------------------------------
     Barra de avisos rotativa. O disclosure FTC é o item 0 e volta sempre —
     a FTC exige que esteja visível no render inicial, por isso começa nele e
     nunca é removido do DOM.
     ---------------------------------------------------------------------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-adv-rotator]'), function (rot) {
    var items = rot.querySelectorAll('.adv-topbar__item');
    if (items.length < 2 || reduce) return;
    var i = 0;
    window.setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 3200);
  });

  /* ------------------------------------------------------------------------
     Comparação por separadores
     ---------------------------------------------------------------------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-adv-tabs]'), function (wrap) {
    var tabs = wrap.querySelectorAll('.adv-comp__tab');
    var panels = wrap.querySelectorAll('.adv-comp__panel');
    Array.prototype.forEach.call(tabs, function (tab, idx) {
      tab.addEventListener('click', function () {
        Array.prototype.forEach.call(tabs, function (t, k) {
          var on = k === idx;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        Array.prototype.forEach.call(panels, function (p, k) {
          var on = k === idx;
          p.classList.toggle('is-active', on);
          if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
        track('adv1_comparison_tab', { tab: tab.textContent.trim() });
      });
    });
  });

  /* ------------------------------------------------------------------------
     Carrosséis (depoimentos e tríptico): setas + pontos, sem dependências
     ---------------------------------------------------------------------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-adv-carousel]'), function (track_) {
    var items = track_.children;
    if (items.length < 2) return;
    var nav = track_.parentNode.querySelector('[data-adv-carnav]');
    if (!nav) return;
    var dots = nav.querySelectorAll('.adv-carnav__dot');
    var prev = nav.querySelector('[data-dir="prev"]');
    var next = nav.querySelector('[data-dir="next"]');

    function current() {
      var best = 0, min = Infinity;
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(items[i].offsetLeft - track_.scrollLeft);
        if (d < min) { min = d; best = i; }
      }
      return best;
    }
    function sync() {
      var c = current();
      Array.prototype.forEach.call(dots, function (d, i) {
        d.classList.toggle('is-active', i === c);
      });
    }
    function go(i) {
      var n = Math.max(0, Math.min(items.length - 1, i));
      track_.scrollTo({ left: items[n].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    Array.prototype.forEach.call(dots, function (d, i) {
      d.addEventListener('click', function () { go(i); });
    });
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });

    var t;
    track_.addEventListener('scroll', function () {
      window.clearTimeout(t);
      t = window.setTimeout(sync, 90);
    }, { passive: true });
    sync();
  });

  /* ------------------------------------------------------------------------
     Barras das métricas: enchem quando entram no ecrã (padrão da PDP)
     ---------------------------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var barObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        barObs.unobserve(entry.target);
      });
    }, { threshold: 0.3 });
    Array.prototype.forEach.call(root.querySelectorAll('.adv-metrics__i'), function (el) {
      barObs.observe(el);
    });
  } else {
    Array.prototype.forEach.call(root.querySelectorAll('.adv-metrics__i'), function (el) {
      el.classList.add('is-in');
    });
  }
})();
